/* eslint-disable camelcase */
const de = {
  common: {
    copied: 'Kopiert',
    course: {
      zero: '%{courses_capitalized}',
      one: '%{course_capitalized}',
      other: '%{courses_capitalized}'
    },
    follower: {
      zero: 'Follower',
      one: 'Follower',
      other: 'Follower'
    },
    leader: {
      zero: 'Leiter',
      one: 'Leiter',
      other: 'Leiter'
    }
  },
  joi: {
    fields: {
      date_of_birth: 'Geburtsdatum',
      email: 'E-Mail-Adresse',
      partner_email: 'E-Mail-Adresse des Partners',
      first_name: 'Vorname',
      last_name: 'Nachname',
      phone: 'Telefonnummer',
      student: '%{member_capitalized}',
      role: 'Rolle',
      partner_gegevens: 'Partnerdetails',
      woonplaats: 'Stadt',
      hoe_heb_je_ons_gevonden: 'Wie hast du uns gefunden?',
      fields_name: 'Feldname',
      fields_id: 'Feld-ID',
      fields_type: 'Feldtyp',
      fields_mandatory: 'Pflichtfeld',
      fields_category: 'Kategorie',
      fields_value: '%{name}',
    },
    templates: {
      base: '%{field} %{message}'
    },
    string: {
      base: 'sollte eine Zeichenkette sein.',
      empty: 'darf nicht leer sein',
      min: 'sollte mindestens %{number} Zeichen enthalten.',
      max: 'sollte höchstens %{number} Zeichen enthalten.',
      length: 'hat nicht die angegebene exakte Länge.',
      email: 'ist keine gültige E-Mail-Adresse.',
      regex: {
        base: 'entspricht nicht dem angegebenen regulären Ausdruck.'
      },
      restricted_email: 'vom Partner darf nicht dieselbe sein wie die des Käufers.',
      invalid_email: 'ist ungültig.'
    },
    number: {
      base: 'sollte eine Zahl sein.',
      min: 'ist kleiner als das angegebene Minimum.',
      max: 'ist größer als das angegebene Maximum.',
      integer: 'ist keine ganze Zahl.'
    },
    date: {
      base: 'ist kein gültiges Datum.',
      min: 'liegt vor dem angegebenen Mindestdatum.',
      max: 'liegt nach dem angegebenen Höchstdatum.'
    },
    boolean: {
      base: 'sollte ein boolescher Wert sein.'
    },
    array: {
      base: 'sollte ein Array sein.',
      min: 'enthält weniger Elemente als das angegebene Minimum.',
      max: 'enthält mehr Elemente als das angegebene Maximum.'
    },
    object: {
      base: 'sollte ein Objekt sein.',
      unknown: 'enthält nicht erlaubte Felder.'
    },
    any: {
      invalid: 'enthält ein ungültiges Token.',
      required: 'wurde nicht angegeben.',
      only: 'entspricht keiner der erlaubten Werte.'
    }
  },
  installments: {
    delete_failed: 'Das Entfernen ist nicht gelungen. Bitte versuche es erneut.'
  },
  mailings: {
    editor: {
      first_name: 'Vorname',
      last_name: 'Nachname',
      placeholders: 'Platzhalter'
    }
  },
  payment_form: {
    on_waitlist: 'Auf Warteliste',
    people_waiting: {
      one: '1 Person auf der Warteliste',
      other: '%{count} Personen auf der Warteliste'
    },
    discount_code: {
      check: 'Prüfen'
    },
    payments: {
      new: {
        alerts: {
          select_bank: 'Bitte wähle deine Bank',
          select_plan: 'Bitte wähle deinen Plan',
          agree_terms: 'Bitte stimme den Bedingungen zu'
        },
        ideal_terms: 'Ich stimme zu, dass %{amount} von meinem IBAN in jeder neuen Periode abgebucht wird.',
        credit_card_terms: 'Ich stimme zu, dass %{amount} von meinem Kreditkarte in jeder neuen Periode abgebucht wird.'
      }
    },
    utils: {
      texts: {
        available: 'Verfügbar',
        select_course: 'Wähle %{number} %{object}, die du besuchen möchtest',
        student_explanatory: 'Bitte füge deine Details hinzu',
        student_explanatory_student: 'Details des Kindes (der %{member})',
        partner_explanatory: 'Bitte füge die Partnerdetails hinzu',
        partner_explanatory_student: 'Partnerdetails',
        spots_left: {
          zero: '0 Plätze frei',
          one: '1 Platz frei',
          other: '%{count} Plätze frei'
        },
        starts_on: 'Beginnt am',
        waitlist: 'Warteliste beitreten',
        trial_class: '%{trial_class_capitalized}',
        waitlisted: 'Momentan ist es nicht möglich, sich als %{role1} anzumelden, ' +
                    'weil wir versuchen, die %{class} ausgeglichen zu halten. ' +
                    'Ein Platz wird verfügbar, sobald sich ein neuer %{role2} anmeldet.',
        couple_available: 'Als Paar verfügbar',
        couple_not_available: 'Nicht verfügbar',
        couple_leader_title: 'Deine Daten',
        couple_leader_explanatory: 'Gib deine Daten als Leader ein',
        couple_follower_title: 'Partnerdaten',
        couple_follower_explanatory: 'Gib die Daten des Followers ein',
      }
    },
    errors: {
      no_more_spots: 'Leider sind keine Plätze mehr verfügbar',
      no_spots_left_for: 'Leider keine Plätze mehr für %{role} verfügbar',
      no_dance_class_selected: 'Bitte wähle mindestens einen %{course} aus oder klicke auf "Später wählen"'
    }
  }
};
/* eslint-enable camelcase */

export default de;
